<template>
  <grid-item xs="12" lg="4">
    <h1>Уведомления</h1>
    <white-bg :style="{'min-height': !notifications ? '350px': 'auto'}">
      <preload-content :loading="!notifications">
        <template v-if="notifications">
          <h2>Уведомления</h2>
          <template v-if="notifications.length">
            <div class="not" :key="idx" v-for="(notificationsItem, idx) in notifications">
              <div class="not__body">
                <div class="not__body-text">
                  {{ notificationsItem.text }}
                </div>
                <div class="not__body-date">
                  <div v-if="notificationsItem.created_at">
                    {{ notificationsItem.created_at }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div v-else>
            Список пуст
          </div>
          <div class="bonuses__more" v-if="notificationsPage !== notificationsLastPage">
            <button @click="loadNotifications(true)">Показать больше</button>
          </div>
        </template>
      </preload-content>
    </white-bg>

  </grid-item>
</template>

<script>
import preloadContent from '../../../components/ui/preload-content';
import WhiteBg from '../../../components/ui/white-bg'
import GridItem from '../../../components/grid/GridItem'

export default {
  name: 'Notifications',
  components: {WhiteBg, GridItem, preloadContent},
  data() {
    return {
      notifications: null,
      notificationsPage: 1,
      notificationsLastPage: 1,
    }
  },
  mounted() {
    this.loadNotifications();
  },
  methods: {
    setNotifications(data, more = false) {
      more ? data.data.map((val) => this.notifications.push(val)) : this.notifications = data.data;
      this.notificationsPage = data.meta.current_page;
      this.notificationsLastPage = data.meta.last_page;
    },
    loadNotifications(more = false) {
      if (more) this.notificationsPage += 1;
      return this.$api.client.notification.list(this.notificationsPage).then((data) => this.setNotifications(data, more));
    },
  }
}
</script>

<style scoped lang="scss">
h1 {
  display: none;
}

h2 {
  margin-top: -15px;
  padding-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #383838;
}

.not {
  padding-top: 10px;
  margin: 0 -30px 0 -30px;
  border-top: 1px solid #E5E5E5;

  &__body {
    margin: 0 30px 0 30px;

    &-text {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #383838;
    }

    &-date {
      display: flex;
      flex-wrap: wrap;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      color: #808080;
      padding-bottom: 5px;
    }
  }
}
.bonuses {
  &__more {
    button {
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background-color: transparent;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #B9765B;

      &:after {
        content: '';
        width: 20px;
        height: 20px;
        margin-left: 5px;
        background-image: url("../../../assets/images/icons/chevron-down.svg");
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
  }
}

@media screen and (max-width: 900px) {
  h1 {
    display: block;
    padding-top: 0;
    margin-top: -15px;
    margin-bottom: 15px;
    font-size: 24px;
    line-height: 1.33;
    color: #383838;
    margin-left: -15px;
  }

  .whiteBg {
    padding: 15px !important;
    margin: 0 -30px;
  }

  h2 {
    display: none;
  }
}

</style>
